import Table from "components/Template/Table";
import React from "react";
import { useHistory } from "react-router-dom";
import { ReactComponent as Change } from "icons/change-status.svg";
import ButtonIcon from "components/ButtonIcon";
import Eye from "icons/eye.svg";
import EyeDisabled from "icons/eye-disabled.svg";
import Edit from "icons/edit.svg";
import EditDisabled from "icons/edit-disabled.svg";
import Close from "icons/close-circle.svg";
import CloseDisabled from "icons/confirm-circle-green.svg";

type Props = {
  dataList: any;
  setDataList: React.Dispatch<React.SetStateAction<any[]>>;
  status: string;
  setStatus: React.Dispatch<React.SetStateAction<string>>;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  setEnabled: React.Dispatch<React.SetStateAction<any>>;
  setChangeStatus: React.Dispatch<React.SetStateAction<string>>;
};

const TableEntity: React.FC<Props> = ({
  dataList,
  setDataList,
  status,
  setStatus,
  setShow,
  setEnabled,
  setChangeStatus,
}): JSX.Element => {
  let history = useHistory();

  const showChangeStatus = async (data: any) => {
    setShow(true);
    setEnabled(data);
  };

  const orderStatus = () => {
    if (status === "asc") {
      setDataList(
        [...dataList].sort((a: any, b: any) => (a.active > b.active ? 1 : -1))
      );
      setStatus("desc");
    } else {
      setDataList(
        [...dataList].sort((a: any, b: any) => (a.active > b.active ? -1 : 1))
      );
      setStatus("asc");
    }
  };

  const uppercaseFirstLetter = (name: string): string => {
    let newName = "";
    if (name === "active") {
      newName = "Active";
    }

    if (name === "disabled" || !name || name === "") {
      newName = "Disabled";
    }

    if (name === "pending") {
      newName = "Pending";
    }

    return newName;
  };

  return (
    <Table
      childrenThead={
        <tr className="font-sora">
          <td className="px-7">Name</td>
          <td>Email</td>
          <td>
            <div className="flex flex-row">
              Status
              <button className="ml-2" onClick={orderStatus}>
                <Change />
              </button>
            </div>
          </td>
          <td>View</td>
          <td>Edit</td>
          <td>Disable</td>
        </tr>
      }
      childrenTbody={
        <>
          {dataList.length > 0 &&
            dataList.map((data: any, i: number) => (
              <tr
                className={`font-sora ${
                  data.status === "active"
                    ? "text-bt-black"
                    : "text-bt-gray-500"
                }`}
                key={i}
              >
                <td className="px-7 py-7">{data.name}</td>
                <td>{data.email}</td>
                <td>
                  <div
                    className={`flex flex-col mt-1 text-bt-white justify-center items-center h-12 w-24 rounded-full ${
                      data.status === "active"
                        ? "bg-bt-light-green"
                        : "bg-bt-gray-400"
                    }`}
                  >
                    {uppercaseFirstLetter(data.status)}
                  </div>
                </td>
                <td style={{ width: "70px" }}>
                  {data.status === "active" ? (
                    <ButtonIcon
                      icon={Eye}
                      onClick={() => {
                        history.push(`/entity-management/${data._id}/details`);
                      }}
                      status={true}
                    />
                  ) : (
                    <ButtonIcon icon={EyeDisabled} status={false} />
                  )}
                </td>
                <td style={{ width: "70px" }}>
                  {data.status === "active" ? (
                    <ButtonIcon
                      icon={Edit}
                      onClick={() => {
                        history.push(`/entity-management/${data._id}/edit`);
                      }}
                      status={true}
                    />
                  ) : (
                    <ButtonIcon icon={EditDisabled} status={false} />
                  )}
                </td>
                <td style={{ width: "70px" }}>
                  {data.status === "active" ? (
                    <ButtonIcon
                      icon={Close}
                      status={true}
                      onClick={() => {
                        setChangeStatus("inactive");
                        showChangeStatus(data);
                      }}
                    />
                  ) : (
                    <ButtonIcon
                      icon={CloseDisabled}
                      status={true}
                      onClick={() => {
                        setChangeStatus("active");
                        showChangeStatus(data);
                      }}
                    />
                  )}
                </td>
              </tr>
            ))}
        </>
      }
    />
  );
};

export default TableEntity;
